import brand1 from './brandnew2/1.png';
import brand2 from './brandnew2/2.png';
import brand3 from './brandnew2/3.png';
import brand4 from './brandnew2/4.png';
import brand5 from './brandnew2/5.png';
import brand6 from './brandnew2/6.png';
import brand7 from './brandnew2/7.png';
import brand8 from './brandnew2/8.png';
import brand9 from './brandnew2/9.png';
import brand10 from './brandnew2/10.png';
import brand11 from './brandnew2/11.png';
import brand12 from './brandnew2/12.png';
import brand13 from './brandnew2/13.png';
import brand14 from './brandnew2/14.png';
import brand15 from './brandnew2/15.png';
import brand16 from './brandnew2/16.png';
import brand17 from './brandnew2/17.png';

const brands = [
  brand1, brand2, brand3, brand4, brand5, brand6, brand7, brand8, brand9, brand10,
  brand11, brand12, brand13, brand14, brand15, brand16, brand17
];

export default brands;
